export const RUNNING = 'running';
export const SNOOZED = 'snoozed';
export const DELAYED = 'delayed';
export const WAITING = 'waiting';

export const COMPLETED = 'completed';
export const FAILED = 'failed';
export const ABORTED = 'aborted';
export const REJECTED = 'rejected';
export const SKIPPED = 'skipped';
export const EXPIRED = 'expired';

export const ACTIVE_RUN_STATUSES = [RUNNING];
export const COMPLETE_RUN_STATUSES = [COMPLETED, FAILED, ABORTED];

export const ACTIVE_TASK_STATUSES = [RUNNING, SNOOZED];
export const UPCOMING_TASK_STATUSES = [WAITING, DELAYED];
export const COMPLETE_TASK_STATUSES = [
  COMPLETED,
  FAILED,
  ABORTED,
  REJECTED,
  SKIPPED,
  EXPIRED
];

export const INCOMPLETE_STATUSES = [
  ...new Set([
    ...ACTIVE_RUN_STATUSES,
    ...ACTIVE_TASK_STATUSES,
    ...UPCOMING_TASK_STATUSES
  ])
];

export const COMPLETE_STATUSES = [
  ...new Set([...COMPLETE_RUN_STATUSES, ...COMPLETE_TASK_STATUSES])
];



// WEBPACK FOOTER //
// ./js/const/status.js